import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 保存空运出口航班客户
export function saveAirExportFlightCustomer(data) {
  return request({
    url: URL.booking.airExport.saveAirExportFlightCustomer,
    method: 'post',
    data
  })
}
